import { ICommandBase } from '@/commands/interface/iCommandBase';
import { PatternBaseLayer } from '@/model/document2/page/surface/design/layer/patternBaseLayer';
import { ColorConstruct } from '@/utilityModels/colorConstruct';

// 図形のグラデーション追加コマンド
export class AddGradationOfPatternCommand implements ICommandBase
{
    private layer! : PatternBaseLayer;
    private position! : number;
    private color! : ColorConstruct;
    private doneCallback! : () => void;

    private index : number = 0;
    private selected : number = 0;

    constructor(layer : PatternBaseLayer, position : number, color : ColorConstruct, doneCallback : () => void)
    {
        this.layer = layer;
        this.position = position;
        this.color = color;
        this.doneCallback = doneCallback;

        this.selected = this.layer.selectedGradationPoint;
    }

    public do() : void
    {
        // グラデーション追加
        this.index = this.layer.addGradation(this.position, this.color);
        // 追加したグラデーションをカレントにする
        this.layer.selectedGradationPoint = this.index;

        this.doneCallback();
    }

    public undo() : void
    {
        // 追加したindexでグラデーションを削除
        this.layer.removeGradation(this.index);
        // カレントを戻す
        this.layer.selectedGradationPoint = this.selected;

        this.doneCallback();
    }

    public redo() : void
    {
        // グラデーション追加
        this.index = this.layer.addGradation(this.position, this.color);
        // 追加したグラデーションをカレントにする
        this.layer.selectedGradationPoint = this.index;

        this.doneCallback();
    }
}